import React from "react";

import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Image, Text } from "@mantine/core";
import { ImageIcon } from "~/../../base-components/lib/assets/icons.generated";
import { networkByNameLookup } from "~/../../shared-features/lib/utils/blockExplorer";

import { CollectionStandardType, NetworkType } from "apollo/graphql.generated";
import {
  ContractDetailsQuery,
  CollectionDetailsQuery,
} from "~/features/gates/queries/gates.graphql.generated";

import PreviewCollectionTile from "../PreviewCollectionTile";

export type CustomCollectionDetails = {
  network?: NetworkType;
  address?: string;
  name: string;
  imageUrl: string;
  standard?: string;
  items?: string;
};

export type Props = {
  network?: NetworkType;
  collection?:
    | CollectionDetailsQuery
    | ContractDetailsQuery
    | CustomCollectionDetails;
  onClear: () => void;
};

const CollectionDetailsSection = ({ collection, onClear, network }: Props) => {
  if (!collection) {
    return <></>;
  }

  let imageUrl = "";
  let name = "";
  let standard = "";

  const networkDisplayName =
    network && networkByNameLookup(network).displayName;
  //const items = "505 items"; // TODO jj, get collection count

  if ((collection as CollectionDetailsQuery).collectionDetails) {
    const details: CollectionDetailsQuery["collectionDetails"] = (
      collection as CollectionDetailsQuery
    ).collectionDetails;
    imageUrl = details.imageUrl || "";
    name = details.name;
    standard = details.standard?.toString() || "";
    if (networkDisplayName != null) {
      standard = `${networkDisplayName} • ${standard}`;
    }
  } else if ((collection as ContractDetailsQuery).contractDetails) {
    const details: ContractDetailsQuery["contractDetails"] = (
      collection as ContractDetailsQuery
    ).contractDetails;
    imageUrl = details.imageUrl || "";
    name = details.name || "";
    standard = details.standard?.toString() || "";
    if (networkDisplayName != null) {
      standard = `${networkDisplayName} • ${standard}`;
    }
  } else {
    const details = collection as CustomCollectionDetails;
    imageUrl = details?.imageUrl || "";
    name = details?.name || "";
    standard = details?.standard?.toString() || "";
    if (networkDisplayName != null) {
      standard = `${networkDisplayName} • ${standard}`;
    }
  }

  if (!standard) {
    return <></>;
  }

  return (
    <PreviewCollectionTile
      image={
        <Image
          src={imageUrl}
          fit="contain"
          width={68}
          height={68}
          radius={5}
          withPlaceholder
          placeholder={<ImageIcon width={24} height={24} />}
        ></Image>
      }
      title={
        <Text fw={500} size={"sm"} lineClamp={2}>
          {name}
        </Text>
      }
      subtitle={
        <>
          <Text size={"xs"} color={TEXT_COLOR.SECONDARY}>
            {standard === CollectionStandardType.OPENSEA ? "OpenSea" : standard}
            {/* {" ∙ " + items} */}
          </Text>
        </>
      }
      onEdit={() => {
        onClear();
      }}
    />
  );
};

export default CollectionDetailsSection;
